import React from "react";
import "./ThreeCircles.css";

const DEFAULT_COLOR = "#4fa94d";

const PATH_OUTER =
  "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z";
const PATH_MIDDLE =
  "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z";
const PATH_INNER =
  "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z";

/**
 * Same visual as react-loader-spinner ThreeCircles, but uses CSS keyframe rotation
 * instead of SVG SMIL so the spinner stays smooth when the main thread is busy.
 */
function ThreeCircles({
  wrapperStyle = {},
  visible = true,
  wrapperClass = "",
  height = 100,
  width = 100,
  color = DEFAULT_COLOR,
  ariaLabel = "three-circles-loading",
  outerCircleColor,
  innerCircleColor,
  middleCircleColor,
}) {
  if (!visible) {
    return null;
  }

  const outer = outerCircleColor || color;
  const middle = middleCircleColor || color;
  const inner = innerCircleColor || color;
  const h = height;
  const w = width;

  return (
    <div
      style={{ display: "flex", ...wrapperStyle }}
      className={wrapperClass}
      data-testid="three-circles-wrapper"
      aria-label={ariaLabel}
      aria-busy="true"
      role="progressbar"
    >
      <svg
        version="1.1"
        height={h}
        width={w}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        xmlSpace="preserve"
        className="three-circles-loader__svg"
        data-testid="three-circles-svg"
        aria-hidden
      >
        <g className="three-circles-loader__g three-circles-loader__g--outer">
          <path fill={outer} d={PATH_OUTER} />
        </g>
        <g className="three-circles-loader__g three-circles-loader__g--middle">
          <path fill={middle} d={PATH_MIDDLE} />
        </g>
        <g className="three-circles-loader__g three-circles-loader__g--inner">
          <path fill={inner} d={PATH_INNER} />
        </g>
      </svg>
    </div>
  );
}

export { ThreeCircles };
export default ThreeCircles;
